'use strict';

import {fnToastrFormError, pjaxRefreshPage, printResponse} from "../jquery-functions-library";
import {element_exists} from "../functions";

export var fnPayrollApproval = function () {

    var elementName = '#selected_payroll';

    $.ajaxSetup({headers: {'X-CSRF-TOKEN': $('[name="_token"]').val()}});

    if (!element_exists(elementName)) return false;

    const btnApprove = $('#btn-approve-payroll');


    var lang = allLangFiles.salary.js;

    btnApprove.off('click').on('click', function (e) {
        e.preventDefault();

        var self = this;

        var url = $(this).attr('data-href');

        $.confirm({
            title: $(self).attr('data-lang'),
            content: lang.confirm,
            theme: 'supervan',
            columnClass: 'col-md-12',
            backgroundDismiss: true,
            buttons: {
                Ja: {
                    action: function () {
                        var employeeList = $.map(window.payrollTable, function (employee) {
                            if (!employee.status) {
                                return `${employee.first_name} ${employee.last_name}`;
                            }
                        });

                        if (employeeList.length > 0) {
                            openSecondConfirm(employeeList);
                        } else {
                            $.ajax({
                                url: url,
                                success: function (response) {
                                    printResponse(response);
                                    pjaxRefreshPage();
                                },
                                error: fnToastrFormError,
                            });
                        }
                    },
                    text: lang.yes
                },
                Nej: {
                    text: lang.no
                }
            }
        });


        function openSecondConfirm(employeeList) {
            var lang = allLangFiles.payrolls;

            $.confirm({
                title: $(self).attr('data-lang'),
                content: lang.changes.confirm_1 + '<br>' + employeeList.join(', ') + '<br><br>' + lang.changes.confirm_2,
                theme: 'supervan',
                columnClass: 'col-md-12',
                backgroundDismiss: true,
                buttons: {
                    Ja: {
                        action: function () {

                            $.ajax({
                                url: url,
                                success: function (response) {
                                    printResponse(response);
                                    pjaxRefreshPage();
                                },
                                error: fnToastrFormError,
                            });
                        },
                        text: lang.yes
                    },
                    Nej: {
                        text: lang.no
                    }
                }
            });
        }
    });
};
